module.exports = __webpack_public_path__ + "static/img/开盘-3.b89a67cc.png";